module.exports = __webpack_public_path__ + "static/media/spinner.843d9df4.gif";